<a mat-list-item (click)="toggleMenu()" routerLinkActive #rla="routerLinkActive"
  [class.active-menu-item-2]="rla.isActive || isChildActive()" 
  [matTooltip]="!expanded ? item.nombre : null"
  matTooltipPosition="right">
  <div class="menu-item">
    <mat-icon class="menu-icon">{{item.urlIcon || getIconForItem(item.nombre)}}</mat-icon>
    <span class="menu-text" *ngIf="expanded">{{item.nombre}}</span>
    <mat-icon class="expand-icon" *ngIf="expanded">
      {{hidden ? 'expand_more' : 'expand_less'}}
    </mat-icon>
  </div>
</a>

<div *ngIf="!hidden" class="submenu">
  <ng-container *ngFor="let app of item.apps">
    <ng-container *ngIf="!app.isExterno; else externo">
      <a mat-list-item [routerLink]="[app.url]" routerLinkActive="active-menu-item"
        #rlaApp="routerLinkActive" [activated]="rlaApp.isActive" [matTooltip]="!expanded ? app.nombre : null"
        matTooltipPosition="right">
        <div class="menu-item submenu-item">
          <mat-icon class="menu-icon-circle">{{app.urlIcon || 'fiber_manual_record'}}</mat-icon>
          <span class="menu-text" *ngIf="expanded">{{app.nombre}}</span>
        </div>
      </a>
    </ng-container>
    <ng-template #externo>
      <a mat-list-item href="{{app.url}}" target="_blank" (click)="handleExternalClick($event)"
        [matTooltip]="!expanded ? app.nombre : null" matTooltipPosition="right">
        <div class="menu-item submenu-item">
          <mat-icon class="menu-icon-circle">{{app.urlIcon || 'fiber_manual_record'}}</mat-icon>
          <span class="menu-text" *ngIf="expanded">{{app.nombre}}</span>
          <mat-icon class="external-icon" *ngIf="expanded">open_in_new</mat-icon>
        </div>
      </a>
    </ng-template>
  </ng-container>
  <mat-divider></mat-divider>
</div>